import { render } from "./TrashButtonExpanding.vue?vue&type=template&id=6ffc1fdc&scoped=true"
import script from "./TrashButtonExpanding.vue?vue&type=script&lang=js"
export * from "./TrashButtonExpanding.vue?vue&type=script&lang=js"

import "./TrashButtonExpanding.vue?vue&type=style&index=0&id=6ffc1fdc&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffc1fdc"]])

export default __exports__